<template lang="html">
    <section class="registro">
        <encabezado :data="'generarNuevoConvenio'"></encabezado>
        <form class="form row-start ais container">
            <p><strong>Por favor, cumplimente los siguientes datos, una vez recibida la solicitud generaremos el
                    Convenio de Cooperación Educativa entre su empresa y UFV.</strong></p>
            <div class="contenedor-input type-text full-slot">
                <firmanteConvenioSelect :errorFirst="noCompletFirmanteConvenio"
                    @setFirmanteConvenio="setFirmanteConvenio" :idFirmanteConvenio="data.idFirmanteConvenio"
                    v-validate="'required'" v-model="data.idFirmanteConvenio" name="idFirmanteConvenio"
                    :class="[{ 'has-error': errors.has('idFirmanteConvenio') }]"></firmanteConvenioSelect>
                <span class='error'>{{ errors.first('idFirmanteConvenio') }}</span>
            </div>
            <div class="contenedor-input type-text full-slot">
                <label>Copia de la escritura de poderes*</label>
                <p>Adjunte documento con la copia de la escritura que otorga poderes de firma a la persona indicada como
                    Firmante del convenio en el campo anterior.​</p>
                <dropzone v-validate="'required'" name="ficheroCopiaEscritura" @emit="setDoc" ref="dropzone"
                    v-model="data.ficheroCopiaEscritura.ficheroB64"
                    :class="[{ 'has-error': errors.has('ficheroCopiaEscritura') }]"></dropzone>
                <span class='error'>{{ errors.first('ficheroCopiaEscritura') }}</span>
            </div>
            <div class="container type-text full-slot row-start m-0 p-0" v-if="paises && tiposVia">
                <div class="contenedor-input type-text full-slot  p-0 mb-0" v-if="!!!editDireccion">
                    <p>
                        <strong>{{ $t('registro.direccion_empresa') }}:</strong>
                        <template v-if="!!tiposVia[empresa.idTipoViaDireccion]">
                            {{ tiposVia[empresa.idTipoViaDireccion] }}
                        </template>
                        <template v-if="!!empresa.direccion">
                            {{ empresa.direccion }}
                        </template>
                        <template v-if="!!empresa.direccionNumero">
                            , {{ $t('registro.numero') }}:{{ empresa.direccionNumero }}
                        </template>
                        <template v-if="!!empresa.direccionEscalera">
                            , {{ $t('registro.escalera') }}:{{ empresa.direccionEscalera }}
                        </template>
                        <template v-if="!!empresa.direccionPuerta">
                            , {{ $t('registro.puerta') }}:{{ empresa.direccionPuerta }}
                        </template>
                        <template v-if="!!empresa.direccionPiso">
                            , {{ $t('registro.piso') }}:{{ empresa.direccionPiso }}
                        </template>
                        <template v-if="!!empresa.localidad">
                            , {{ empresa.localidad }}
                        </template>
                        <template v-if="!!provinciasComplet[empresa.provincia]">
                            , {{ provinciasComplet[empresa.provincia].nameProvincia
                            }}
                        </template>
                        <template v-if="!!empresa.pais">
                            , {{paises.filter(item => item[0] == empresa.pais)[0][1]}}
                        </template>
                        <template v-if="!!empresa.cp">
                            , {{ empresa.cp }}
                        </template>
                    </p>
                    <p v-if="!!empresa.DPO">
                        <strong>DPO: </strong>{{ empresa.DPO }}
                    </p>
                    <p v-if="!!empresa.linkLOPD">
                        <strong>Link LOPD: </strong>{{ empresa.linkLOPD }}
                    </p>
                </div>
                <template v-else>
                    <div class="contenedor-input type-text full-slot  p-0">
                        <label class="w-100">{{ $t('registro.direccion_empresa') }}:</label>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="pais">{{ $t('registro.pais') }}*</label>
                        <select name="pais" v-model="empresa.pais" @change="setProvincia">
                            <option value="">{{ $t('registro.selecciona_pais') }}</option>
                            <option v-if="!!paises" v-for="(el, key) in paises" :value="Number(el[0])">{{ el[1] }}
                            </option>
                        </select>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="">{{ $t('oferta.provincia') }}*</label>
                        <input type="text" name="provincia" v-model="data.provinciaOtros" v-if="empresa.pais != 1"
                            autocomplete='nope'>
                        <select name="provincia" v-model="empresa.provincia" autocomplete='nope' v-else>
                            <option value="" selected disabled>{{ $t('registro.selecciona_provincia') }}</option>
                            <option v-if="!!provinciasComplet" v-for="(el, key) in provinciasComplet"
                                :value="el.idProvincia">{{
                                    el.nameProvincia }}</option>
                        </select>
                    </div>
                    <div class="contenedor-input one-slot">
                        <label for="">{{ $t('registro.localidad') }}</label>
                        <select name="localidadcontacto" v-model="empresa.idLocalidad"
                            v-if="(empresa.pais == '1') && empresa.provincia" autocomplete="none">
                            <option value="" selected disabled>{{ $t('registro.selecciona_localidad') }}</option>
                            <option v-if="!!provinciasComplet[empresa.provincia].localidades"
                                v-for="(el, key) in provinciasComplet[empresa.provincia].localidades" :value="key">{{ el
                                }}
                            </option>
                        </select>
                        <input autocomplete="off" type="text" name="localidadcontacto" v-model="empresa.localidadOtros"
                            v-else>
                    </div>
                    <div class="contenedor-input one-slot">
                        <label for="">{{ $t('registro.tipo_via') }}*</label>
                        <select name="tipo_via" v-model="empresa.idTipoViaDireccion">
                            <option value="" selected disabled>{{ $t('registro.selecciona_tipo_via') }}</option>
                            <option v-if="!!tiposVia" v-for="(el, key) in tiposVia" :value="Number(key)">
                                {{ el }}
                            </option>
                        </select>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="direccion">{{ $t('registro.nombre_via') }}*</label>
                        <input type="text" name="direccion" v-model="empresa.direccion">
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="numero">{{ $t('registro.numero') }}</label>
                        <input type="text" name="numero" v-model="empresa.direccionNumero">
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="escalera">{{ $t('registro.escalera') }}</label>
                        <input type="text" name="escalera" v-model="empresa.direccionEscalera">
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="puerta">{{ $t('registro.puerta') }}</label>
                        <input type="text" name="puerta" v-model="empresa.direccionPuerta">
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="piso">{{ $t('registro.piso') }}</label>
                        <input type="text" name="piso" v-model="empresa.direccionPiso">
                        <span class='error' v-if="clicked">{{ errors.first('piso') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="codigo_postal">{{ $t('registro.cp') }}*</label>
                        <input type="number" v-validate="'required|numeric'" name="codigo_postal" v-model="empresa.cp">
                    </div>
                    <!-- <div class="contenedor-input type-text one-slot -wo-margin">
                        <label for="DPO">DPO</label>
                        <input type="text" name="dpo" v-model="empresa.DPO" v-validate="'email'">
                        <span class='error' v-if="clicked">{{ errors.first('dpo') }}</span>
                    </div> -->
                    <div class="contenedor-input type-text one-slot">
                        <div class="container-label-info">
                            <label for="">DPO*
                            </label>
                            <popup-info :texto="'dpo'" :side="'right'"></popup-info>
                        </div>
                        <input type="text" name="dpo" v-model="empresa.DPO" autocomplete='nope'
                            v-validate="'required|email'">
                        <span class='error' v-if="clicked">{{ errors.first('dpo') }}</span>
                    </div>
                    <div class="contenedor-input type-text one-slot">
                        <div class="container-label-info">
                            <label for="">Link LOPD*
                            </label>
                        </div>
                        <input type="text" name="linkLOPD" v-model="empresa.linkLOPD" autocomplete='nope'
                            v-validate="'required|url'">
                        <span class='error' v-if="clicked">{{ errors.first('linkLOPD') }}</span>
                    </div>
                </template>
                <div class="contenedor-input type-text full-slot  p-0" v-if="!!!editDireccion">
                    <p @click="editDireccion = true">Si los datos mostrados no son correctos, pinche <u
                            class="cursor-pointer">aquí</u>
                        para editarlos.</p>
                </div>
            </div>
            <div class="contenedor-botones mb50">
                <a class="btn -solid-primary" @click="validar">Solicitar convenio</a>
            </div>
        </form>
    </section>
</template>
<script lang="js">
import encabezado from '@/components/parts/encabezado';
import firmanteConvenioSelect from '@/components/parts/form/firmantes-convenio-select';
import dropzone from '@/components/parts/form/dropzone'
import popupInfo from '@/components/parts/popup-info';
import { mapGetters, mapActions } from 'vuex';
export default {
    name: 'solicitud-cambio-practica',
    components: {
        'encabezado': encabezado,
        firmanteConvenioSelect,
        dropzone,
        'popup-info': popupInfo,
    },
    mounted() {
        this.requestDominiosTiposVia();
    },
    computed: {
        ...mapGetters({
            empresa: 'getDatosEmpresa',
            tiposVia: 'getTiposVia',
            provinciasComplet: 'getProvinciasComplet',
            paises: 'getPaises',
        })
    },
    data() {
        return {
            clicked: false,
            editDireccion: false,
            noCompletFirmanteConvenio: true,
            data: {
                idFirmanteConvenio: null,
                idPais: null,
                idProvincia: null,
                provinciaOtros: "",
                idLocalidad: null,
                localidadOtros: "",
                direccion: "",
                cp: "",
                idTipoVia: null,
                direccionNumero: "",
                direccionEscalera: "",
                direccionPiso: "",
                direccionPuerta: "",
                ficheroCopiaEscritura: {
                    "ficheroB64": null,
                    "extension_adjunto": null
                },
                DPO: '',
                linkLOPD: ''
            }
        }
    },
    methods: {
        ...mapActions(['addConvenioEmpresa', 'requestDominiosTiposVia']),
        isValidUrl(value) {
            if (!value) {
                return false;
            }
            try {
                const parsedUrl = new URL(value);
                return parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
            } catch (e) {
                return false;
            }
        },
        setFirmanteConvenio(data) {
            this.data.idFirmanteConvenio = parseInt(data.id)
        },
        setDoc(value) {
            this.data.ficheroCopiaEscritura.ficheroB64 = value.ficheroB64ParaAltas;
            this.data.ficheroCopiaEscritura.extension_adjunto = value.extension_adjunto;
        },
        setProvincia() {
            if (this.empresa.pais != 1) {
                this.empresa.provinciaOtros = '';
            }
        },
        validar() {
            if (this.empresa.DPO == '' || this.empresa.DPO == null) {
                this.editDireccion = true
                this.$validator.errors.add({ field: 'dpo', msg: 'El campo DPO es obligatorio' });
            }
            if (this.empresa.linkLOPD == '' || this.empresa.linkLOPD == null) {
                this.editDireccion = true
                this.$validator.errors.add({ field: 'linkLOPD', msg: 'El campo Link LOPD es obligatorio' });
            } else if (!this.isValidUrl(this.empresa.linkLOPD)) {
                this.editDireccion = true
                this.$validator.errors.add({ field: 'linkLOPD', msg: 'El campo Link LOPD debe ser una URL valida (http:// o https://)' });
            }
            this.clicked = true;
            this.$validator.validateAll().then(itsOk => {
                this.data.cp = this.empresa.cp
                this.data.direccion = this.empresa.direccion
                this.data.direccionEscalera = this.empresa.direccionEscalera
                this.data.direccionNumero = this.empresa.direccionNumero
                this.data.direccionPiso = this.empresa.direccionPiso
                this.data.DPO = this.empresa.DPO
                this.data.direccionPuerta = this.empresa.direccionPuerta
                this.data.idLocalidad = this.empresa.idLocalidad
                this.data.idPais = this.empresa.pais
                this.data.idProvincia = parseInt(this.empresa.provincia)
                this.data.idTipoVia = parseInt(this.empresa.idTipoViaDireccion)
                this.data.localidadOtros = this.empresa.localidad
                this.data.linkLOPD = this.empresa.linkLOPD
                this.data.DPO = this.empresa.DPO
                // this.data.provinciaOtros = this.empresa.provinciaOtros
                if (itsOk) {
                    this.clicked = false;
                    console.log(this.data);
                    this.addConvenioEmpresa(this.data)
                } else {
                    $('html,body').animate({ scrollTop: 0 }, 400);
                }
            })
        },
    },

}
</script>
<style scoped lang="scss">
form {
    padding-top: 50px;
}

.epigrafe {
    margin-bottom: 20px;
}

.container-label-info .popup-info {
    right: -30px;
    top: -5px;
}
</style>


// WEBPACK FOOTER //
// src/components/views/documentacion/generar-nuevo-convenio.vue